var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.chips),function(chip,i){return _c('v-chip',{key:`chip=${i}`,attrs:{"close":""},on:{"click":function($event){return _vm.select(chip.filter)},"input":function($event){return _vm.clear(chip.filter)}}},[_vm._v("\n    "+_vm._s(_vm.getDescription(chip))+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }